module.exports = __webpack_public_path__ + "static/media/i4c-bottom.5bac0224.svg";